<style lang="scss" scoped>
i {
  font-size: 80px;
}

.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;
}

.modal-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  vertical-align: middle;
  min-height: 100%;
}

.modal-container {
  width: 375px;
  height: 375px;
  margin: 0px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: white;
  border-radius: 2px;
  transition: all 0.3s ease;
  color: white;
  border-radius: 7px;
  .fa-check {
    width: 73px;
    height: 73px;
    border: 1px solid;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 50px;
  }
  .fa-spin {
    color: #666;
    font-size: 30px;
  }
  .fa-exclamation-triangle {
    font-size: 73px;
  }
  &.success {
    background: #4caf50;
  }
  &.error {
    background: red;
  }
}
.modal-body {
  text-align: center;
  padding: 15px;
  .message {
    margin: 1rem 0;
    font-size: 1.4rem;
    line-height: 2rem;
  }
}
.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}
</style>

<template>
  <transition name="modal">
    <div class="modal-mask" v-if="show">
      <div class="modal-wrapper">
        <div class="modal-container" :class="{ loading, success, error }">
          <div class="modal-body">
            <slot name="body">
              <i class="fa fa-check" v-if="success"></i>
              <i class="fa fa-exclamation-triangle" v-else-if="error"></i>
              <i class="fa fa-spinner fa-spin" v-else-if="loading"></i>
            </slot>
            <p class="message">{{ message }}</p>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      success: false,
      error: false,
      message: '',
    };
  },
  computed: {
    show() {
      return this.loading || this.success || this.error;
    },
  },
};
</script>
